// ============================================
// Author						: Prabakaran
// Description			:
// Date							:
// ============================================
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'scroll-top',
  templateUrl: './scroll-top.component.html'
})
export class ScrolltopComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// E:/GangaJewallery-Final/app.server/systemic.app.server/client/src/main/app/@layout/scroll-top/scroll-top.component.ts